'use client';

import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { PromoToolSlot } from '@/types/amplience';
import { isScheduledItemExpired } from '@/utility/isScheduledItemExpired';
import {
  clearActivePromoCode,
  getActivePromoCode,
  isUrlCoupon,
  setActivePromoCode,
  setUrlCoupon,
} from '@/utility/promos';

export const promoConfigAtom = atom<PromoToolSlot | null>(
  (get) => get(overwrittenPromoConfigAtom) || get(cachedPromoConfigAtom)
);
export const isPromoExpiredAtom = atom<boolean>((get) => {
  const promoConfig = get(promoConfigAtom);
  return promoConfig ? isScheduledItemExpired(promoConfig.content._meta) : true;
});
export const overwrittenPromoConfigAtom = atom<PromoToolSlot | null>(null);
export const cachedPromoConfigAtom = atom<PromoToolSlot | null>(null);

export type PromoCode = {
  code: string;
  expires: Date | null;
  // true when activated automatically (a `?couponCode=` URL param or a campaign with
  // `autoApplyCoupon` flag on): session-scoped, applied without condition checks.
  fromUrl?: boolean;
};
export const activePromoCodeAtom = atomWithStorage<PromoCode | null>('activePromoCode', null, {
  getItem: (key: string, initialValue) => {
    if (typeof window === 'undefined') {
      return initialValue;
    }
    const code = getActivePromoCode();
    if (!code) {
      return null;
    }
    return { code, expires: null, fromUrl: isUrlCoupon() };
  },
  setItem: (key: string, newValue) => {
    if (typeof window === 'undefined' || !newValue) {
      return;
    }
    if (newValue.fromUrl) {
      setUrlCoupon(newValue.code);
    } else {
      setActivePromoCode(newValue.code, newValue.expires);
    }
  },
  removeItem: () => {
    clearActivePromoCode();
  },
});

export const initialPromoCountAtom = atom(0);

export const openPromoPopupAtom = atom(false);
